module.exports = __webpack_public_path__ + "media/src/images/godivalogo-455474e7e8c163352851fc3f58c00259.svg";